export default __webpack_public_path__ + "static/l-shadow-cs@2x-e540b9c08272ae178824a64c801e5957.png";